import * as React from "react";
import Start from "../components/views/Start";

const IndexPage = () =>
{
    return (
        <Start />
    );
};
export default IndexPage;
